import React, { memo } from 'react'
import qs from 'qs'
import { Navigate, useRoutes } from 'react-router-dom'
import { RouteType } from '@/types/common'

import App from '@/App'
import { isUndefined } from 'lodash-es'

const Home = React.lazy(() => import('@/pages/home'))
const SchoolInfoEdit = React.lazy(() => import('@/pages/school-info/school-info-edit'))
const SchoolInfoDetail = React.lazy(() => import('@/pages/school-info/school-info-detail'))
const LessonChoose = React.lazy(() => import('@/pages/lesson-choose'))
const TeacherInfo = React.lazy(() => import('@/pages/teacher-info'))
const ClassInfo = React.lazy(() => import('@/pages/class-info'))
const ClassInfoEmpty = React.lazy(() => import('@/pages/class-info-empty'))
const StudentInfo = React.lazy(() => import('@/pages/student-info'))
const Schedule = React.lazy(() => import('@/pages/schedule'))
const Teach = React.lazy(() => import('@/pages/teach'))
const LessonDetail = React.lazy(() => import('@/pages/lesson-detail'))
const ChooseLessonSchoolInfo = React.lazy(() => import('@/pages/choose-lesson-school-info'))
const FastLogin = React.lazy(() => import('@/pages/fast-login'))

interface BaseRouteObject {
  path?: string,
  element?: JSX.Element,
  routeKey?: string,
  menuKey?: string,
  children?: BaseRouteObject[],
  extraData?: any,
}

export const index: BaseRouteObject[] = [
  {
    path: '',
    routeKey: 'App',
    menuKey: 'App',
    element: <App />,
    children: [
      {
        path: '/home/:formid?',
        routeKey: 'Home',
        element: <Home />,
      },
      {
        path: '/school-info-edit/:formid/:schoolModuleId/:lessonModuleId?',
        routeKey: 'SchoolInfoEdit',
        element: <SchoolInfoEdit />,
      },
      {
        path: '/school-info-detail/:formid/:schoolModuleId',
        routeKey: 'SchoolInfoDetail',
        element: <SchoolInfoDetail />,
      },
      {
        path: '/lesson-choose/:formid/:lessonModuleId/:schoolModuleId?',
        routeKey: 'LessonChoose',
        element: <LessonChoose />,
      },
      {
        path: '/teacher-info/:formid/:id',
        routeKey: 'TeacherInfo',
        element: <TeacherInfo />,
      },
      {
        path: '/class-info/:formid/:id',
        routeKey: 'ClassInfo',
        element: <ClassInfo />,
      },
      {
        path: '/start-class/:formid/:id',
        routeKey: 'ClassInfoEmpty',
        element: <ClassInfoEmpty />,
      },
      {
        path: '/student-info/:formid/:id',
        routeKey: 'StudentInfo',
        element: <StudentInfo />,
      },
      {
        path: '/schedule/:formid/:id',
        routeKey: 'Schedule',
        element: <Schedule />,
      },
      {
        path: '/teach/:formid/:id',
        routeKey: 'Teach',
        element: <Teach />,
      },
      {
        path: '/lesson-detail/:formid/:id/:lessonId/:uuid/:from',
        routeKey: 'LessonDetail',
        element: <LessonDetail />,
      },
      {
        path: '/lesson-school-info/:formid/:lessonModuleId/:schoolModuleId',
        routeKey: 'ChooseLessonSchoolInfo',
        element: <ChooseLessonSchoolInfo />,
      },
      {
        path: '/fast-login',
        routeKey: 'FastLogin',
        element: <FastLogin />,
      },
      {
        path: '/',
        routeKey: 'root',
        element: <Navigate to="/home" />,
      },
      {
        path: '*',
        routeKey: '',
        element: <Navigate replace to="/home" />,
      },
    ],
  },
]

const urlMap: any = {}
const paramReg = /:\w+/g

function makeNameToPathMap(cusRouteConfigs: BaseRouteObject[], parentPath = '') {
  for (const route of cusRouteConfigs) {
    const path = parentPath ? `${parentPath}/${route.path}` : route.path
    if (route.routeKey) {
      urlMap[route.routeKey] = path
    }
    if (route.children) {
      makeNameToPathMap(route.children, path)
    }
  }
}

makeNameToPathMap(index)

export function resolveRoute(route: RouteType) {
  const { name, params, query } = route
  let path = urlMap[name]
  if (!path) {
    return ''
  }
  const paramsList = path.match(paramReg)

  if (params && paramsList) {
    paramsList.forEach((p: any) => {
      const key = p.slice(1)

      if (isUndefined(params[key])) {
        const result = path.match(/\/:\w+\?/g)
        path = path.replace(result, '')
      } else {
        path = path.replace(p, params[key])
      }
    })
  }
  if (query) {
    path = `${path}?${qs.stringify(query, { arrayFormat: 'repeat' })}`
  }

  return path
}

// 渲染路由
function RouteElement() {
  return (
    <>
      {useRoutes(index)}
    </>
  )
}

export default memo(RouteElement)
